<template>
  <div class="h-6 lg:h-8 mr-2">
    <button @click="showMenu = !showMenu"
            class="relative rounded border-current text-white"
            :class="[ disabled ? 'cursor-default bg-gray-500' : ' bg-gray-800 hover:bg-gray-500' ]"
            :disabled="disabled">
      <div class="absolute">
        <div  v-if="isReference"
              class="overflow-hidden w-6 h-6 lg:h-8 lg:w-8 p-1 m-1">
          <IconCogDouble></IconCogDouble>
        </div>
        <div
          v-if="!isReference"
          class="w-6 h-6 lg:w-8 lg:h-8 p-1"
        >
          <IconCog></IconCog>
        </div>
      </div>
      <div class="p-1 w-6 h-6 lg:w-8 lg:h-8"></div>
    </button>
    <div
      :class="{ hidden: !showMenu }"
      class="absolute z-10 right-0 lg:right-auto mt-0 mr-4 w-auto rounded-md shadow-lg"
    >
      <div class="rounded-md bg-white shadow-xs">
        <div class="py-1">
          <button
            @click="$emit('toggle-active')"
            class="block w-full px-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >{{ active ? 'Disable' : 'Enable' }}</button>
          <button
            @click="$emit('duplicateRow')"
            class="block w-full px-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >Duplicate</button>
          <div class="focus:outline-none leading-5 px-4 py-2 text-gray-700 text-left text-sm w-full whitespace-no-wrap">
            <ColorPicker :selectedColor="color" @color-selected="colorSelected" />
          </div>
          <button
            v-if="isReference"
            @click="$emit('convertToIndependent')"
            class="block w-full px-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >Convert to independent</button>
          <button
            @click="$emit('deleteRow')"
            class="block w-full px-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColorPicker from '@/components/row/ColorPicker'
import IconCog from '@/components/icons/IconCog'
import IconCogDouble from '@/components/icons/IconCogDouble'

export default {
  name: 'RowContextMenu',
  components: {
    ColorPicker,
    IconCog,
    IconCogDouble
  },
  props: {
    isReference: {
      type: Boolean,
      default: false
    },
    source: String,
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: true
    },
    color: String
  },
  data() {
    return {
      showMenu: false
    };
  },
  methods: {
    hideMenu() {
      this.showMenu = false;
    },
    colorSelected(color){
      this.$emit('color-selected', color)
      this.hideMenu()
    }
  },
  created() {
    window.addEventListener('click', this.hideMenu, true);
  },
  destroyed() {
    window.removeEventListener('click', this.hideMenu);
  }
};
</script>